// app/middleware/notFoundKings.ts
import { useWebContext } from "~/composables/webContext";

export default defineNuxtRouteMiddleware(() => {
  const { isKings } = useWebContext();

  if (isKings) {
    throw createError({ statusCode: 404 });
  }
});
